/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { useEffect } from "react";

import useUniqueId from "./useUniqueId";

const useWatchForm = ({
  methods,
  keyArray,
  callback,
}: {
  methods: any;
  keyArray?: string;
  callback?: (e: { value: any; name: string; type: "change" }) => void;
}) => {
  const [arrayChange, updateArrayChange] = useUniqueId();
  useEffect(() => {
    const subscription = methods?.watch((_value: any, { name, type }: any) => {
      if (callback) {
        callback({ value: _value, name, type });
      }
      if (keyArray) {
        if (type === "change" && name?.includes(keyArray)) {
          updateArrayChange();
        }
      }
    });

    return () => subscription?.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return arrayChange;
};

export default useWatchForm;
